import type { TranslationTree } from '../../types';

export const backendConfig: TranslationTree = {
  backendConfig: {
    badge: 'Super-Admin',
    title: 'Backend-Konfiguration',
    description:
      'Externe Verbindungen, die je nach Deployment variieren. Änderungen werden live übernommen — kein Neustart erforderlich.',
    influx: {
      title: 'InfluxDB',
      description:
        'Die Signaldatenbank, die von der Seite Signale, den Live-Vorhersagen und dem Maschinenformular gelesen wird. Der Signals-Worker verwendet diese Anmeldedaten für Nur-Lese-Abfragen.',
      savedMessage: 'Der Signals-Worker verwendet diese InfluxDB-Verbindung bei seiner nächsten Anfrage.',
    },
    fields: {
      influxHost: { label: 'Host' },
      influxPort: { label: 'Port' },
      influxUser: { label: 'Benutzer' },
      influxPassword: { label: 'Passwort' },
      influxDatabase: { label: 'Datenbank' },
    },
    save: 'Speichern',
    reset: 'Zurücksetzen',
    retry: 'Erneut versuchen',
    saved: 'Konfiguration gespeichert',
    usingDefaults: {
      title: 'Deployment-Standardwerte aktiv',
      body: 'Es ist noch keine benutzerdefinierte Konfiguration gespeichert — die Felder zeigen die im .env dieses Deployments hinterlegten Werte. Beim Speichern wird eine Überschreibung angelegt.',
    },
    errors: {
      forbidden: 'Sie benötigen Admin-Rechte, um diese Einstellung zu ändern.',
      generic: 'Beim Speichern ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      loadFailed: 'Konfiguration konnte nicht geladen werden.',
    },
    loading: 'Konfiguration wird geladen…',
  },
};
